import { useMutation, useQuery } from '@tanstack/react-query';

import type { TQueryHookOptions } from '@/_state/apis/react-query-helpers';
import { instructorRequest } from '@/_state/apis/react-query-helpers';
import type { FetchBaseQueryError } from '@/_state/apis/tanstack-api';
import type { TInstructorMeModel } from '@/_student/profile/model';

import { instructorTransformResponse } from '../../_student/profile/helper';

const meInstructorDependencyQueryKey = ['instructorApis', 'meInstructorDependency'] as const;

export const useUpdateMeDependencyMutation = () => {
  return useMutation<string, FetchBaseQueryError, Record<string, unknown>>({
    mutationFn: (body) =>
      instructorRequest<string>('updateMeDependency', {
        url: 'me/',
        method: 'PUT',
        body,
      }),
    retry: false,
  });
};

export const useMeInstructorDependencyQuery = (options?: TQueryHookOptions<TInstructorMeModel>) => {
  return useQuery<TInstructorMeModel, FetchBaseQueryError>({
    queryKey: meInstructorDependencyQueryKey,
    queryFn: () =>
      instructorRequest<TInstructorMeModel>('meInstructorDependency', 'me/', (response) =>
        instructorTransformResponse(response as TInstructorMeModel)
      ),
    ...options,
    retry: false,
  });
};
